import { z } from "zod";
export const updateIcalSourceSchema = z.object({
    name: z.string().min(1).max(200).optional(),
    bookings_only: z.boolean().optional(),
});
